<template>
  <div class="wrapper" @scroll.prevent>
    <Header></Header>
    <div class="flex-wrap">
      <div class="content-left">
        <div class="seat">
          <span style="color:rgba(153,153,153,1);">当前位置：</span>
          <router-link to="/">首页></router-link>
          <span class="coord" v-text="'投诉和消息中心'"></span>
        </div>
        <!--当前位置-->
        <div class="myMsg-wrap">
          <div class="tabs">
            <span v-on:click="active=1" v-bind:class="[ active === 1 ? 'active' : '' ]">我的信息</span>
            <span v-on:click="active=2" v-bind:class="[ active === 2 ? 'active' : '' ]">我的投诉</span>
          </div>
        </div>
      </div>
      <div class="content-right">
        <div class="title" v-if="active===1">我的信息</div>
        <div class="title" v-if="active===2">
          <div class="tabs">
            <a
              v-on:click="changeTab(1)"
              :class="[ activetab === 1 ? 'activetab' : '' ]"
              id="tab-change1"
            >待审核</a>
            <a
              v-on:click="changeTab(2)"
              :class="[ activetab === 2 ? 'activetab' : '' ]"
              id="tab-change2"
            >已通过</a>
            <a
              v-on:click="changeTab(3)"
              :class="[ activetab === 3 ? 'activetab' : '' ]"
              id="tab-change3"
            >已驳回</a>
          </div>
        </div>

        <hr>

        <!--我的信息-->
        <div class="progress-wrap" v-if="active===1">
          <div class="progress" v-for="item in ComplainData.listData">
            <div class="progress-module">
              <div class="article-title" v-text="item.result"></div>
              <span class="time" v-text="item.update_time">2019.02.10</span>
              <div class="article-text">
                {{item.call}}
                <span class="article-name" v-text="'《'+item.order+'》'"></span>
                {{item.status_title}}
              </div>

              <router-link
                class="view-detail"
                v-if="item.types===1"
                :to="{ path: 'complainInfo',query:{id:item.order_id}}"
              >查看详情>></router-link>

              <router-link
                class="view-detail"
                v-if="item.types===2"
                :to="{path:'/ComplainContent',query:{id:item.order_id}}"
              >查看详情>></router-link>

              <router-link
                class="view-detail"
                v-if="item.types===3"
                :to="{path:'article',query:{id:item.order_id}}"
              >查看详情>></router-link>
            </div>
          </div>
        </div>

        <!--我的投诉-->
        <div class="progress-wrap" v-if="active===2">
          <div id="tabs" class="container">
            <div class="content">
              <!--待审核-->
              <div v-if="activetab === 1" class="tabcontent">
                <div class="progress" v-for="item in ComplainListData">
                  <div class="progress-module">
                    <div class="article-title" v-text="item.title"></div>
                    <span class="time" v-text="item.create_time">2019.02.10</span>
                    <div class="article-text" v-text="item.detail"></div>
                    <router-link
                      class="view-detail"
                      :to="{path:'/complainContent',query:{id:item.id}}"
                    >查看详情>></router-link>
                  </div>
                </div>
              </div>

              <!--已通过-->
              <div v-if="activetab === 2" class="tabcontent">
                <div class="progress" v-for="item in ComplainListData">
                  <div class="progress-module">
                    <div class="article-title" v-text="item.title"></div>
                    <span class="time" v-text="item.create_time">2019.02.10</span>
                    <div class="article-text" v-text="item.detail"></div>
                    <router-link
                      class="view-detail"
                      :to="{path:'/complainContent',query:{id:item.id}}"
                    >查看详情>></router-link>
                  </div>
                </div>
              </div>
              <!--已驳回-->
              <div v-if="activetab === 3" class="tabcontent">
                <div class="progress" v-for="item in ComplainListData">
                  <div class="progress-module">
                    <div class="article-title" v-text="item.title"></div>
                    <span class="time" v-text="item.create_time">2019.02.10</span>
                    <div class="article-text" v-text="item.detail"></div>
                    <router-link
                      class="view-detail"
                      :to="{path:'/complainContent',query:{id:item.id}}"
                    >查看详情>></router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page-number" v-if="active===1">
          <span v-text="'第'+ComplainData.page+'页'"></span> /
          <span v-text="'共'+ComplainData.totalPage+'页'"></span>
          <span class="page-ref">
            <button @click="homePage">首页</button>
            <button @click="upPage">上一页</button>
            <button @click="downPage">下一页</button>
            <button @click="lastPage">尾页</button>
          </span>
        </div>
        <div class="page-number" v-if="active===2">
          <span v-text="'第'+contentPage+'页'"></span> /
          <span v-text="'共'+complainAllpage+'页'"></span>
          <span class="page-ref">
            <button @click="homePage">首页</button>
            <button @click="upPage">上一页</button>
            <button @click="downPage">下一页</button>
            <button @click="lastPage">尾页</button>
          </span>
        </div>
      </div>
    </div>

    <HomeFoot></HomeFoot>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import HomeFoot from "@/components/HomeFoot.vue";

export default {
  name: "ComplainCenter",
  components: { Header, HomeFoot },
  data() {
    return {
      active: 1,
      token: "",
      activetab: 1,
      ComplainData: "",
      ComplainList: "",
      ComplainRate: 1,
      ComplainRatePage: 1,
      contentPage: 1,
      myMsgPage: 1,
      ComplainListData: "", //我的投诉进度
      complainAllpage: "" //我的投诉所有页数
    };
  },
  mounted() {
    this.active = 1;
    this.token = localStorage.getItem("token");
    this.getComplainResule();
    this.getComplainList();
    // 每次刷新页面都跳转到页面顶部
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  methods: {
    //获取我的消息列表
    getComplainResule() {
      this.$post("https://315sd.0532.name/api/general/message_list", {
        token: this.token,
        page: this.myMsgPage
      })
        .then(res => {
          if (res.code === 0) {
            this.ComplainData = res.data;
            // console.log(res.data, '我的信息接口');
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    changeTab(type) {
      this.activetab = type;
      this.getComplainList(type);
    },
    //获取我的投诉列表
    getComplainList(type) {
      this.$post("https://315sd.0532.name/api/general/complaint_list", {
        token: this.token,
        types: this.activetab,
        page: this.ComplainRatePage
      })
        .then(res => {
          if (res.code === 0) {
            this.complainAllpage = res.data.totalPage;
            this.contentPage = res.data.page;
            this.ComplainListData = res.data.listData;
            // console.log(this.ComplainListData, '获取我的投诉列表');
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //点击上下页执行的函数
    getNewsList(page) {
      if (this.active === 1) {
        this.$post("https://315sd.0532.name/api/general/message_list", {
          token: this.token,
          page: page
        })
          .then(res => {
            if (res.code === 0) {
              this.ComplainData = res.data;
              document.body.scrollTop = document.documentElement.scrollTop = 0;
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else if (this.active === 2) {
        this.$post("https://315sd.0532.name/api/general/complaint_list", {
          token: this.token,
          page: page,
          types: this.activetab
        })
          .then(res => {
            if (res.code === 0) {
              this.ComplainListData = res.data.listData;
              document.body.scrollTop = document.documentElement.scrollTop = 0;
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },

    homePage() {
      this.getNewsList(1);
    },

    upPage() {
      if (this.active === 1) {
        if (this.myMsgPage < this.ComplainData.totalPage) {
          this.myMsgPage -= 1;
          this.getNewsList(this.myMsgPage);
        } else {
          this.$message("已经是第一页.");
        }
      } else if (this.active === 2) {
        if (this.contentPage < this.complainAllpage) {
          this.contentPage -= 1;
          this.getNewsList(this.contentPage);
        } else {
          this.$message("已经是第一页了.");
        }
        // if (this.ComplainRatePage === 1) {
        //   this.$message('已经是第一页了')
        // } else {
        //   let pageNumber = this.ComplainRatePage -= 1
        //   this.getNewsList(pageNumber)
        // }
      }
    },

    downPage() {
      if (this.active === 1) {
        if (this.myMsgPage < this.ComplainData.totalPage) {
          this.myMsgPage += 1;
          this.getNewsList(this.myMsgPage);
        } else {
          this.$message("已经是最后一页.");
        }
      } else if (this.active === 2) {
        if (this.contentPage < this.complainAllpage) {
          this.contentPage += 1;
          this.getNewsList(this.contentPage);
        } else {
          this.$message("已经是最后一页.");
        }
      }
    },
    // 跳转到尾页
    lastPage() {
      this.getNewsList(this.ComplainData.totalPage);
    }
  }
};
</script>

<style scoped lang="less">
.content-wrap {
  width: 1200px;
  min-height: 500px;
  margin: 32px auto 0 auto;
}

#tab-change1,
#tab-change2,
#tab-change3 {
  width: 59px;
  height: 26px;
  font-size: 22px;
  font-family: MicrosoftYaHei;
  line-height: 26px;
  margin: 0 25px;
  color: rgba(102, 102, 102, 1);
  cursor: pointer;
}

.activetab {
  color: #294b7f !important;
  border-bottom: 1px rgba(41, 75, 127, 1);
}

.progress-wrap {
  min-height: 300px;
}

.flex-wrap {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  margin: 32px auto 0 auto;
}

.myMsg-wrap {
  width: 220px;
  height: 130px;
  background: #f3f3f3;
  padding-top: 16px;
  margin-top: 42px;

  span {
    display: block;
    width: 220px;
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    text-align: center;
    font-family: MicrosoftYaHei;
    color: rgba(102, 102, 102, 1);
    cursor: pointer;
  }

  span:hover {
    /*display: block;*/
    /*width: 220px;*/
    /*height: 45px;*/
    /*line-height: 45px;*/
    /*font-size: 14px;*/
    /*font-family: MicrosoftYaHei;*/
    /*color: rgba(255, 255, 255, 1);*/
    /*background: #294b7f;*/
  }

  .active {
    background: #294b7f;
    color: rgba(255, 255, 255, 1);
  }
}

.content-right {
  width: 924px;
  margin-top: 30px;

  .title {
    height: 26px;
    font-size: 20px;
    font-family: MicrosoftYaHei;
    color: rgba(102, 102, 102, 1);
    line-height: 26px;
  }
}

.progress {
  width: 924px;
  border: 1px solid #eeeeee;
  margin: 8px 0;

  .progress-module {
    width: 924px;
    min-height: 103px;
    margin: 4px 0;
    position: relative;
  }

  .time {
    position: absolute;
    right: 16px;
    top: 0;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 20px;
  }

  .article-title {
    height: 19px;
    font-size: 15px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 19px;
    margin-left: 12px;
    margin-top: 16px;
  }

  .article-text {
    width: 780px;
    min-height: 19px;
    font-size: 15px;
    font-family: MicrosoftYaHei;
    color: rgba(153, 153, 153, 1);
    line-height: 19px;
    margin: 12px;

    span {
      color: #294b7f;
    }
  }

  .view-detail {
    position: absolute;
    right: 16px;
    bottom: 16px;
    margin-left: 12px;
    height: 17px;
    font-size: 13px;
    font-family: MicrosoftYaHei;
    color: rgba(41, 75, 127, 1);
    line-height: 17px;
  }
}

.page-number {
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: rgba(102, 102, 102, 1);
  line-height: 19px;
  width: 924px;
  text-align: center;

  .page-ref > button {
    margin: 10px;
    padding: 0;
    border: 1px solid transparent; //自定义边框
    outline: none;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: rgba(102, 102, 102, 1);
    line-height: 19px;
    background-color: transparent;
    cursor: pointer;
  }
}
</style>
